import moment from 'moment'
import formattersMixin from '@/filters/customFormatters'
import { CAMPAIGN_TYPES, CHANNEL_COLORS, CHANNEL_LABELS } from '@/utils/campaignOptions'
import campaignsUtils from '@/mixins/campaignsUtils'

export default {
  name: 'ChannelHeader',
  mixins: [formattersMixin, campaignsUtils],
  components: {},
  props: {
    campaign: {
      type: Object,
      required: true
    },
    kpis: {
      type: Object,
      required: false
    },
    formValid: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {
    channelColor () {
      return CHANNEL_COLORS[this.type]
    },
    channelLabel () {
      return CHANNEL_LABELS[this.type]
    },
    campaignid () {
      return this.$route.params.campaignid
    },
    type () {
      return this.$route.params.channeltype
    },
    isExterior () {
      return this.campaign && this.campaign.type === CAMPAIGN_TYPES.EXTERIOR
    },
    exteriorBudget () {
      return this.kpis.data.reduce((acum, next) => acum + next.value, 0)
    }
  },
  methods: {
    formatDate (date) {
      // TODO: locale
      return moment(date).locale('es').format('DD/MM/YYYY')
    },
    save () {
      this.$emit('save')
    }
  }
}
